/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface TrackItMeasurementParameterAreaDto
 */
export interface TrackItMeasurementParameterAreaDto {
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterAreaDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof TrackItMeasurementParameterAreaDto
     */
    trackItId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterAreaDto
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItMeasurementParameterAreaDto
     */
    index?: number;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterAreaDto
     */
    unit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItMeasurementParameterAreaDto
     */
    valueX?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TrackItMeasurementParameterAreaDto
     */
    valueY?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementParameterAreaDto
     */
    $type?: TrackItMeasurementParameterAreaDtoTypeEnum;
}


/**
 * @export
 */
export const TrackItMeasurementParameterAreaDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoTrackItMeasurementParameterAreaDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterAreaDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItMeasurementParameterAreaDtoTypeEnum = typeof TrackItMeasurementParameterAreaDtoTypeEnum[keyof typeof TrackItMeasurementParameterAreaDtoTypeEnum];



/**
 * Check if a given object implements the TrackItMeasurementParameterAreaDto interface.
 */
export function instanceOfTrackItMeasurementParameterAreaDto(value?: unknown): value is TrackItMeasurementParameterAreaDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItMeasurementParameterAreaDtoTypeEnum)[0];
}

export function TrackItMeasurementParameterAreaDtoFromJSON(json: any): TrackItMeasurementParameterAreaDto {
    return TrackItMeasurementParameterAreaDtoFromJSONTyped(json, false);
}

export function TrackItMeasurementParameterAreaDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItMeasurementParameterAreaDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'trackItId': json['trackItId'] == null ? undefined : json['trackItId'],
        'name': json['name'] == null ? undefined : json['name'],
        'index': json['index'] == null ? undefined : json['index'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'valueX': json['valueX'] == null ? undefined : json['valueX'],
        'valueY': json['valueY'] == null ? undefined : json['valueY'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItMeasurementParameterAreaDtoToJSON(value?: TrackItMeasurementParameterAreaDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'trackItId': value['trackItId'],
        'name': value['name'],
        'index': value['index'],
        'unit': value['unit'],
        'valueX': value['valueX'],
        'valueY': value['valueY'],
        '$type': value['$type'],
    });
}

